module.exports = __webpack_public_path__ + "static/media/highlighted instructions circle.d8e6ae28.svg";